import { FieldDefinition, FieldBuilder } from '@zendra/shared';
import {
  ConservationTypeService,
  LocationService,
  OtherUseService,
} from 'cbd-proxies';

FieldBuilder.setNamespace('Geographic');

export const OTHERUSEBYCONSERVATIONTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .number('hectare', 'Entity.OtherUseByConservationType.Hectare')
    .required()
    .decimal()
    .build(),
  FieldBuilder.foreignKey(
    'otherUseId',
    'Entity.OtherUseByConservationType.OtherUse',
    OtherUseService,
  )
    .required()
    .display('name')
    .displayFromNested('otherUseName')
    .sortBy('otherUseName')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'registerLocationId',
    'Entity.OtherUseByConservationType.RegisterLocation',
    LocationService,
  )
    .required()
    .display('name')
    .displayFromNested('registerLocationName')
    .sortBy('registerLocationName')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'conservationTypeId',
    'Entity.OtherUseByConservationType.ConservationType',
    ConservationTypeService,
  )
    .display('code')
    .displayFromNested('conservationTypeCode')
    .sortBy('conservationTypeCode')
    .keyField('id')
    .build(),
];

export const OTHERUSEBYCONSERVATIONTYPE_CONFIG = {
  entityName: 'OtherUseByConservationType',
  localizationKey: 'Geographic::Entity.OtherUseByConservationType',
  fields: OTHERUSEBYCONSERVATIONTYPE_FIELDS,
  permission: 'PlanningGeography.OtherUseByConservationTypes',
  showInMenu: false,
};
